import { useMemo } from 'react';

export default function useBookableCurator({ bookables }) {
  return useMemo(() => {
    if (bookables) {
      let parsedBookables;
      parsedBookables = Object.entries(bookables);
      // remove all dates which have no bookables
      parsedBookables = parsedBookables.filter((date) => date[1].length > 0);

      // now sort the timeslots contained in the inner lists of each date
      // according to their start times.
      for (const [, timeslots] of parsedBookables) {
        timeslots.sort((a, b) => {
          if (a.start < b.start) {
            return -1;
          } else if (a.start === b.start) {
            return 0;
          } else {
            return 1;
          }
        });
      }

      // determine type of each bookable
      for (const [, timeslots] of parsedBookables) {
        for (const timeslot of timeslots) {
          // a pure timeslot (an availability) rather than an existing
          // appointment — published so consumers read the flag instead of
          // re-testing kind against the same literal
          timeslot.isAvailability = timeslot.kind === 'models.Bookable';

          if (timeslot.isCancelable) {
            timeslot.renderAsCancelable = true;
          } else if (
            timeslot.capacity_left > 0 ||
            timeslot.isAvailability // capacity doesn't matter for pure tsls
          ) {
            timeslot.renderAsBookable = true;
          } else {
            timeslot.renderAsBlocker = true;
          }
        }
      }

      // now sort the dates themselves
      // ISO format yyyy-MM-dd is lexicographically sortable
      parsedBookables = parsedBookables.sort((a, b) =>
        a[0].localeCompare(b[0]),
      );

      return parsedBookables;
    }

    return [];
  }, [bookables]);
}
